import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import LoginPage from './login';
import ForgotPassword from './forgot_password';
import { Redirect } from 'react-router-dom';

class AuthPage extends Component {
  render() {
    return (
      <Switch>
        <Route path='/login' component={LoginPage} />
        {/* <Route path='/forgot-password' component={ForgotPassword} /> */}
        <Redirect from='*' to='/login' />
    </Switch>
    );
  }
}

export default AuthPage;
